import { isValidPhoneNumber } from 'react-phone-number-input'
import constants from './constants'

const InputValidation = {
    validateEmpty: (value) => {
        // console.log('validateEmpty', value)
        return value === null || value === undefined || value.trim().length === 0 ? "EMPTY_FIELD_ERROR": "";   
    },
    validateNameLength: (value) => {
        var meg = InputValidation.validateEmpty(value);
        if (meg)
            return meg;
        if (value.trim().length > 32)
            return "LIMIT_LENGTH_32"; 
        return "";   
    },
    validatePhone: (value) => {
        if (value !== null && value !== undefined && value.length > 0 && !isValidPhoneNumber(String(value)))
            return "INVALID_PHONE"; 
        return "";   
    },
    validateFirstName: (value) => {
        // console.log('validateNameLength', value)
        if (value && value.trim().length > 32)
            return "LIMIT_LENGTH_0_32"; 
        return "";   
    },
    validateAddress: (value) => {
        var meg = InputValidation.validateEmpty(value);
        if (!meg && value.trim().length > 256)
            return "LIMIT_LENGTH_256"; 
        else if (meg)
            return meg;
        return "";
    },
    validateUserPassword: (value) => {
        value = value.trim();
        if (value.length <= 8 || value.length > 64)
            return "LIMIT_LENGTH_9_64";
        else if (!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{9,}$/.test(value))
            return "INVALID_PASSWORD";
        return "";
    },
    validatePasswordConfirm: (value, value1) => {
        return value.trim() !== value1.trim() ? "PASSWORD_NOT_MATCH" : "";
    },
    validateUserEmail: (value, filterDomain=true) => {
        value = value.trim();
        const emailRegex = /^(?!\.)(?!.*\.$)(?!.*\.\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(?<![.])@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; // /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!/*/^.+@.+\..+$/*/emailRegex.test(value)) {
            return "INVALID_EMAIL";
        } else if (value.length >= 256) {
            return "EMAIL_LIMIT_LENGTH";
        } else if (filterDomain) {
            var domain = value.substring(value.indexOf("@") + 1);
            if (constants.BlockEmailDomainsList.EmailDomains.includes(domain)) {
                return "BLOCK_EMAIL_DOMAIN";
            }
        }
        return "";
    },
    validateLicensesKey: (value) => {
        var meg = InputValidation.validateEmpty(value);
        if (!meg && value.trim().length > 64)
            return "LIMIT_LENGTH_64"; 
        else if (meg)
            return meg;
        return "";
    },
    validateRoleDesc: (value) => {
        return value.trim().length > 256 ? "DESCRIPTION_LIMIT_LENGTH" : "";
    },
    validatePermissions: (value) => {
        return value.length > 0 ? "" : "SELECT_PERMISSION_ERROR";
    }
}

export default InputValidation